import Plyr from "plyr"
const videos = {
  videosClick: document.querySelectorAll(".jsPlayerOnClick") as NodeListOf<HTMLElement>,
  playersClick: [] as Array<Plyr>,

  init() {
    this.videosInit()
    this.onClick()
  },

  videosInit() {
    this.playersClick = Array.from(this.videosClick).map((p) => new Plyr(p))
  },
  onClick() {
    this.playersClick.forEach((item, index) => {
      item.on("play", () => {
        this.playersClick.forEach((el, i) => {
          if (index !== i) {
            el.pause()
          }
        })
      })
    })
  },
}

export default videos
